export default __webpack_public_path__ + "static/media/doctorsPortal.50199584.jpg";